import { REFRESH_TOKEN_FAILURE, REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_SUCCESS } from '@tshio/redux-api-auth-middleware';
import { RSAA, RSAAction } from 'redux-api-middleware';
import { getEnvironmentVar } from 'utils';

import { LoginPayload } from './authorization.types';
import * as types from './authorizationActionTypes';

const objectToParams = (params: object) =>
  Object.keys(params)
    .map(key => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
    })
    .join('&');

export const login = (body: LoginPayload): RSAAction<string, string, string> => ({
  [RSAA]: {
    body: objectToParams({
      grant_type: 'password',
      password: body.password,
      username: body.email,
    }),
    endpoint: 'oauth/token',
    headers: {
      Authorization: `Basic ${getEnvironmentVar('REACT_APP_BASIC_AUTH_KEY')}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    skipAuth: true,
    types: [types.LOGIN_REQUEST, types.LOGIN_SUCCESS, types.LOGIN_FAILURE],
  },
});

export const refreshToken = (token: string): RSAAction<string, string, string> => ({
  [RSAA]: {
    body: objectToParams({
      grant_type: 'refresh_token',
      refresh_token: token,
    }),
    endpoint: 'oauth/token',
    headers: {
      Authorization: `Basic ${getEnvironmentVar('REACT_APP_BASIC_AUTH_KEY')}`,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
    skipAuth: true,
    types: [REFRESH_TOKEN_REQUEST, REFRESH_TOKEN_SUCCESS, REFRESH_TOKEN_FAILURE],
  },
});
